import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto py-6 px-8 border-t border-gray-200 bg-gray-50">
      <div className="flex flex-col md:flex-row justify-between items-center text-xs text-gray-500">
        
        {/* Lado Esquerdo: Copyright */}
        <div className="mb-2 md:mb-0">
          &copy; {currentYear} <span className="font-semibold text-gray-700">OPERYA</span>. Todos os direitos reservados.
        </div>

        {/* Lado Direito: Links ou Versão */}
        <div className="flex items-center space-x-4">
          <a href="#" className="hover:text-blue-600 transition-colors">Suporte</a>
          <a href="https://app.operya.com.br/termos" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 transition-colors">Termos</a>
          <span className="text-gray-300">|</span>
          <span className="text-xs bg-gray-200 px-2 py-1 rounded">v1.0.0</span>
        </div>

      </div>
    </footer>
  );
}